import moment from "moment";

const baseOptions = [10, 20, 30, 40, 50, 100, 200, 400, 500];

/**
 * Format a date string into DD-MM-YYYY
 * @param dateString - ISO date string or any valid date input
 * @returns formatted date string (DD-MM-YYYY) or empty string if invalid
 */
export function formatDate(dateString: string | Date): string {
  if (!dateString) return "";
  const m = moment(dateString);
  return m.isValid() ? m.format("DD-MM-YYYY") : "";
}


// Filter out options greater than vehicleList.length
export const rowsPerPageOptions = (vehicleList: any[]) => [
  ...baseOptions.filter(opt => opt <= vehicleList.length),
  vehicleList.length // always include "all" option
];
